<template>
  <gmap-map
    ref="mapRef"
    :center="rideCenter"
    class="single_ride_map_design"
    :zoom="2"
  >
  </gmap-map>
</template>



<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SingleRideMap',
  computed: mapGetters(['rideCenter']),
  methods: 
  {
    ...mapActions(['rideSetAppMap']),
  },
  mounted(){
    this.$refs.mapRef.$mapPromise.then((map) =>{
      this.$store.commit('rideSetAppMap', map);
      this._resizeObserver = new ResizeObserver(() => {
        google.maps.event.trigger(map, 'resize');
      });
      this._resizeObserver.observe(this.$refs.mapRef.$el);
    });
  },
  beforeDestroy(){
    if (this._resizeObserver) this._resizeObserver.disconnect();
  }
};
</script>
